interface Props {
  className?: string
}

const StagingIndicator = ({ className }: Props) => {
  return (
    <div className={className}>
      <div className='staging-horizontal top-0 left-0 right-0' />
      <div className='staging-horizontal left-0 right-0 bottom-0' />
      <div className='staging-vertical top-0 left-0 bottom-0' />
      <div className='staging-vertical top-0 right-0 bottom-0' />
    </div>
  )
}

export default StagingIndicator
